<template>
  <div id="app">
    <router-view/>
    <!--<videoMessage/>-->
  </div>
</template>

<script>
import http from "./request/http";
import login from "./login";
import {isIphoneX} from './utils/index'
import videoMessage from './components/videoMessage/videoMessage'
export default {
  name: 'App',
  data(){
    return {
      menushow:true,
      path:['/doctorCode','/pdf_template','/download','/dislistpage','/patient_issue_info']
    }
  },
  components:{
    videoMessage
  },
  methods:{
    imlogin(){
      if(this.$cookies.get('app_token')&&this.$cookies.get('openid')){
        this.$imConn.open({
          apiUrl: WebIM.config.apiURL,
          user: this.$cookies.get('app_token'),
          pwd:'dy123456app',
          appKey: WebIM.config.appkey,
          success: (res) =>{
            this.$cookies.set('accessToken',res.access_token)
          }
        });
      }else{
        login.login()
      }
    },
    handleLaunchFn (e) {
      console.log(e)
    },
    handleErrorFn(e){
      console.log('fail', e.detail);
    },
    getCustomerPhone(){
      if(this.$cookies.get('app_token')){
        http.post('/api/wap/public/mobile',).then(res => {
          if(res.errno == 0){
            this.$cookies.set('customer_phone',res.data.mobile)
          }
        })
      }
    },
  },
  mounted() {
    //this.$store.dispatch('getIphoneX',isIphoneX());
    //this.$cookies.set('app_token', 'o0Q0Tt-4iRbODXcVRBCqhuytwFw0');
    //this.$cookies.set('openid', 'o4ZpK52_tyP_y55G8xnHv-_NGQO8');
    //this.$cookies.set('avatar', 'http://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTITZDQGibwxxSwaLjvjT8nbrbvFkCiaKEM8qibGSB1Dv3QLR9BohPR2JkHGrBjhl2icibIIesswn2cnfkQ/132');
    // if(this.path.indexOf(this.$route.path)==-1){
    //   this.imlogin();
    //   this.getCustomerPhone();
    //   http.get('/api/wap/public/wxaddress',{
    //     url:window.location.href
    //   }).then(res=>{
    //     console.log(res)
    //     this.$wx.config({
    //       debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
    //       appId: res.data.appId, // 必填，公众号的唯一标识
    //       timestamp: res.data.timestamp, // 必填，生成签名的时间戳
    //       nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
    //       signature: res.data.signature,// 必填，签名
    //       jsApiList: ['chooseImage'], // 必填，需要使用的JS接口列表
    //       openTagList: ['wx-open-launch-weapp'], // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
    //     })
    //   })
    // }
  }
}
</script>

<style>
  *{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  .body{
    padding: 2.9rem 0 3rem 0;
    min-height: 100vh;
    background: #fafafa;
    overflow-x: hidden
  }
  @media screen and (min-width: 250px) and (max-width: 290px) {
    html{
      font-size: 14px;
    }
  }
  @media screen and (min-width: 320px) and (max-width: 359px) {
    html{
      font-size: 17.07px;
    }
  }
  @media screen and (min-width: 360px) and (max-width: 374px) {
    html{
      font-size: 19.2px;
    }
  }
  @media screen and (min-width: 375px) and (max-width: 385px) {
    html{
      font-size: 20px;
  }
  }
  @media screen and (min-width: 386px) and (max-width: 392px) {
    html {
      font-size: 20.58px;
    }
  }
  @media screen and (min-width: 393px) and (max-width: 400px) {
    html{
      font-size: 21.33px;
    }
  }
  @media screen and (min-width: 401px) and (max-width: 414px) {
    html{
      font-size: 21.97px;
    }
  }
  @media screen and (min-width: 415px) and (max-width: 749px) {
    html{
      font-size: 22.5px;
    }
  }
  @media screen and (min-width: 750px) and (max-width: 799px) {
    html{
      font-size: 40.96px;
    }
  }
  /*@media only screen and (max-width: 374px) { html { font-size: 18px; } }

  @media only screen and (min-width: 375px) { html { font-size: 20px; } }

  @media only screen and (min-width: 384px) { html { font-size: 20.48px; } }

  @media only screen and (min-width: 414px) { html { font-size: 22.08px; } }

  @media only screen and (min-width: 480px) { html { font-size: 25.6px; } }

  @media only screen and (min-width: 640px) { html { font-size: 34.13333px; } }

  @media only screen and (min-width: 750px) { html { font-size: 40px; } }

  @media only screen and (max-width: 319px) { html { font-size: 17.01333px; } }*/

  #app {
    width: 100%;
    height: 100vh;
    overflow-y: auto;
  }
  input,button,textarea,select{
    outline: none;
  }
  .font-85{
    color: rgba(0,0,0,0.85);
  }
  .font-65{
    color: rgba(0,0,0,0.65);
  }
  .font-25{
    color: rgba(0,0,0,0.25);
  }
  .clear{
    clear: both;
  }
  a{
    text-decoration: none;
  }
  .hot-lists {
    padding: 0 0.5rem;
    box-sizing: border-box;
  }
  .hot-lists li {
    position: relative;
    padding: 0.75rem 0 1rem;
    background: #fff;
    border-bottom: 0.05rem solid #ebebeb;
    display: flex;
  }
  .dis-doc-left {
    width: 2.2rem;
    position: relative;
  }
  .hot-lists .item-expert {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    justify-content: space-between;
  }
  .hot-lists .expert-avar {
    width: 2.2rem;
    height: 2.2rem;
    -webkit-border-radius: 50%;
    border-radius: 50%;
    overflow: hidden;
  }
  .all-i {
    display: block;
    width: 100%;
  }
  .icon-jiav, .list-head img.icon-jiav {
    width: 1rem;
    height: 1rem;
    position: absolute;
    left: 1.65rem;
    top: 1.65rem;
    background: url(http://static.dev.dayiketang.com/dypassport/images/icon-jiav.png) no-repeat;
    -webkit-background-size: 0.75rem 0.75rem;
    background-size: 0.75rem;
    vertical-align: top;
  }
  .expert-info {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -moz-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    padding-left: 0.5rem;
    width: 100%;
    overflow: hidden;
  }
  .hot-lists li .expert-info>a {
    display: flex;
    flex-direction: column;
    height: 2rem;
  }
  .expert-name {
    display: inline-block;
    font-size: 0.75rem;
  }
  .expert-pos {
    display: inline-block;
    font-size: 0.65rem;
  }
  .expert-info-good {
    padding-top: 0.25rem;
    font-size: 0.6rem;
    color: #999;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .hot-lists .item-dis.good-hide {
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .hot-lists .item-expert {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    justify-content: space-between;
  }

  .hot-lists .item-dis {
    margin-top: 0.5rem;
    font-size: 0.6rem;
    line-height: 0.75rem;
    color: rgba(0, 0, 0, 0.4);
    height: auto;
    position: relative;
  }
  .doc-btns {
    padding-top: 0.8rem;
  }
  .doc-btns a {
    margin-right: 2rem;
    width: 4rem;
    height: 1rem;
    float: left;
    border: 0.05rem solid rgba(0,0,0,0.08);
    border-radius: 9px;
    font-size: 0.5rem;
    line-height: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .icon.icon-guahao {
    width: 0.6rem;
    height: 0.6rem;
    margin-right: 0.2rem;
    background: url(http://static.dev.dayiketang.com/dypassport/images/phone/icon-an-yygh.png) center center no-repeat;
    background-size: contain;
  }
  .zhankai {
    font-size: 0.5rem;
    position: absolute;
    bottom: 0.25rem;
    right: 0;
    color: #60A7FF;
  }
  .mask{
    width: 100%;
    height: 100vh;
    background: rgba(0,0,0,0.4);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
  }
  .patient-item{
    width: 100%;
    min-height: 2.8rem;
    border-bottom:  0.05rem solid rgba(245, 245, 245, 1);
    line-height: 2.8rem;
    font-size: 0.8rem;
    padding: 0 1rem;
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    background: #fff;
  }
  .submit-btn{
    width: 12rem;
    height: 2rem;
    display: block;
    border-radius: 1rem;
    font-size: 0.8rem;
    color: #fff;
    background: #1890FF;
    border: none;
    margin: 0 auto;
    margin-top: 8rem;
    outline: none;
  }
  .patient-item label{
    width: 3.8rem;
    display: inline-block;
  }
  .patient-item input{
    height: 2.8rem;
  }
  .patient-item textarea{
    margin-bottom:0.4rem;
  }
  .patient-item input,.patient-item textarea{
    border: none;
    background: #fff;
    font-size: 0.8rem;
    outline:none;
    width:80%;
    resize: none;
    line-height: 1.1rem;
  }
  .switch-box{
    background: #fff;
    margin-top: 0.4rem;
    height: auto;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.8rem;
    padding:1rem;
  }
  .switch-box .address-span{
    display: block;
    font-size: 0.6rem;
    height: 0.8rem;
    line-height: 0.8rem;
    margin-top: 0.2rem;
  }
  .patient-list{

    margin-bottom: 0.5rem;
  }
  .select-region{
    position: fixed;
    width: 100%;
    height: 70vh;
    background: #fff;
    border-top: 0.05rem solid #e2e2e2;
    bottom: 0;
    left: 0;
  }
  .select-region>ul{
    width: 100%;
    height: 100%;
    overflow: auto;
    float: left;
    padding: 0 1rem 4.8rem;
  }
  .select-region>ul li{
    list-style-type: none;
    line-height: 1.9rem;
    font-size: 0.7rem;
  }
  .select-region>ul li.active{
    color: #1890FF;
    background: url("./../static/icons/addac@3x.png");
    background-repeat: no-repeat;
    background-size: 0.8rem 0.7rem;
    background-position: center right;
  }

  .input-model{
    height: 20px;
    border: 0.05rem solid #e2e2e2;
  }
  .address-head{
    width: 100%;
    height: 2.7rem;
    border-bottom: 0.05rem solid rgba(245, 245, 245, 1);
    text-align: center;
    padding-top: 1rem;
    font-weight: 700;
    font-size: 0.9rem;
  }
  .address-head span{
    font-size: 1.5rem;
    position: absolute;
    top: 1.3rem;
    right: 1rem;
    font-weight: 400;
    line-height: 0.7rem;
  }
  .address-center{
    width: 100%;
    height: 2rem;
    border-bottom: 0.05rem solid rgba(245, 245, 245, 1);
    padding: 0 1rem;
  }
  .address-center>ul li{
    width: auto;
    float: left;
    list-style: none;
    border-bottom: none;
    font-size: 0.7rem;
    line-height: 2rem;
    margin-right: 1rem;
    position: relative;
  }
  .address-center>ul li.active{
    color: #1890FF;
  }
  .address-center>ul li.active::after{
    content: ' ';
    display: block;
    width: 1.4rem;
    height: 0.1rem;
    background: #1890FF;
    position: absolute;
    bottom: 0;
    left: 50%;
    margin-left: -0.7rem;
  }
  .add-add{
    width: 100%;
    height: 3.2rem;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.8rem;
    color: #1890FF;
    margin-bottom: 0.4rem;
  }
  .icon-add-add{
    content: url("./../static/icons/add-add.png");
    width: 0.8rem;
    height: 0.8rem;
    margin-right: 0.6rem;
  }
  .font-red{
    color: #FA541C;
  }
  .pay-bottom{
    width: 100%;
    height: 2.8rem;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0px -0.1rem 0.2rem 0px rgba(0, 0, 0, 0.02);
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 998;
    padding: 0.6rem 1rem;
    padding-left: 0.5rem;
    box-sizing: border-box;
  }
  .content{
    padding: 0.5rem;
    background: #fafafa;
  }
  .border-card{
    width: 100%;
    height: auto;
    padding: 1rem;
    background: #fff;
    border: 0px solid rgba(245, 245, 245, 1);
    margin-bottom: 0.5rem;
    border-radius: 0.6rem;
    padding-bottom: 0;
    box-sizing: border-box;
  }
  .is-pay{
    width: 100%;
    height: 4rem;
    padding: 0 1rem;
    background: url("./../static/icons/wdbj_bg@3x.png") no-repeat;
    background-size: 100%;
    color: #fff;
    display: flex;
    justify-content: start;
    align-items: baseline;
    padding-top: 1.2rem;
  }
  .pat-card.jiuzhen{
    padding: 0.5rem 1rem;
    text-align: center;
  }
  .pat-card.active{
    border: 0.05rem solid rgba(24, 144, 255, 1);
  }
  .pat-card.jiuzhen{
    padding: 0.5rem 1rem;
    text-align: center;
  }
  .pat-card{
    width: 7.4rem;
    background: #fafafa;
    float: left;
    padding: 1rem;
    border-radius: 0.25rem;
    margin-bottom: 1rem;
    font-size: 0.8rem;
    border: 0.05rem solid #fff;
    position: relative;
  }
  .pat-card:nth-child(2n+1){
    float: right;
  }

  .bottom{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 7.65rem;
  }
  .checks{
    width: 100%;
    height: 3.9rem;
    background: #F4FAFF;
    font-size: 0.7rem;
    padding: 0.5rem;
    display: flex;
    justify-content: space-between;
  }
  .icon-check{
    content: url("./../static/icons/unselected@3x.png");
    width: 0.6125rem;
    height: 0.6125rem;
    margin-right: 0.5rem;
    margin-top: 0.2rem;
  }
  .icon-checked{
    width: 0.6rem;
    height: 0.6rem;
    content: url("./../static/icons/selected@3x.png");
  }
  .btns{
    width: 100%;
    height: 3.75rem;
    background: #fff;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    padding-bottom: 1rem;
  }
  .border-card.active{
    border: 0.1rem solid rgba(24, 144, 255, 1);
    position: relative;
  }
  .border-card.active:after{
    content: '';
    width: 1.5rem;
    height: 1.5rem;
    background: url('./../static/icons/xuanzeyiyuan@3x.png') no-repeat;
    background-size: 1.5rem;
    position: absolute;
    bottom: 0;
    right: 0;
  }
  .pat-card.active{
    border: 0.05rem solid rgba(24, 144, 255, 1);
  }
  .pat-card.active::after{
    content: '';
    background: url("./../static/icons/xuanzeyiyuan@2x.png") no-repeat center center;
    background-size: 1rem 1rem;
    width: 1rem;
    height: 1rem;
    position: absolute;
    bottom: 0;
    right: 0;
  }
  .border-card h3{
    line-height: 1.3rem;
    font-size: 0.9rem;
    margin-bottom: 0.5rem;
  }

  .pay-left{
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .kefu{
    width: 1.8rem;
    height: 100%;
    font-size: 0.6rem;
    text-align: center;
    padding-right: 0.4rem;
    border-right: 0.05rem solid rgba(0,0,0,0.09);
    color: rgba(0,0,0,0.65);
    box-sizing: border-box;
  }
  .icon-kefu{
    content: url("../static/icons/customservice@3x.png");
    width: 0.8rem;
    height: 0.8rem;
    display: block;
    margin: 0 auto;
  }
  .pay-price{
    color: #FA541C;
    font-size: 0.8rem;
    line-height: 1;
    padding-left: 0.5rem;
  }
  .pay-btn{
    width: 100%;
    height: 2rem;
    background-image: linear-gradient(#43A3FF,#4790FF);
    color: #fff;
    text-align: center;
    border-radius: 1rem;
    line-height: 2rem;
    font-size: 0.8rem;
  }
  input::-webkit-input-placeholder{
    color: rgba(0, 0, 0, 0.25);
    font-size: 0.8rem;
  }
  input:-moz-placeholder{
    color: rgba(0, 0, 0, 0.25);
    font-size: 0.8rem;
  }
  input::-moz-placeholder{
    color: rgba(0, 0, 0, 0.25);
    font-size: 0.8rem;
  }
  input:-ms-input-placeholder{
    color: rgba(0, 0, 0, 0.25);
    font-size: 0.8rem;
  }
  textarea::-webkit-input-placeholder{
    color: rgba(0, 0, 0, 0.25);
    font-size: 0.8rem;
  }
  textarea:-moz-placeholder{
    color: rgba(0, 0, 0, 0.25);
    font-size: 0.8rem;
  }
  textarea::-moz-placeholder{
    color: rgba(0, 0, 0, 0.25);
    font-size: 0.8rem;
  }
  textarea:-ms-input-placeholder{
    color: rgba(0, 0, 0, 0.25);
    font-size: 0.8rem;
  }
  .el-switch,.el-switch__core{
    width: 2.6rem !important;
    height: 1.6rem !important;
    line-height: 1.6rem !important;
  }
  .el-switch__core{
    border-radius: 0.8rem !important;
  }
  .el-switch__core:after{
    content: "";
    position: absolute;
    top: 0.05rem;
    left: 0.1rem;
    border-radius: 100%;
    -webkit-transition: all .3s;
    transition: all .3s;
    width: 1.4rem !important;
    height: 1.4rem !important;
    background-color: #FFF;
  }
  .el-switch.is-checked .el-switch__core::after{
    margin-left: -1.45rem !important;
  }
  .highlights-text{
    color: #FA541C;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue